import { useState } from 'react';

export default function useToken() {
  const getToken = () => {
    const tokenString = sessionStorage.getItem('sales_account_token');
    return tokenString
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
   
    sessionStorage.setItem('sales_account_token', JSON.stringify(userToken));
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token
  }
}
